export const LOGS_TRANSLATIONS = {
    en: {
      title: "MediLens",
      subtitle: "AI-Powered PubMed Search",
      backToSearch: "Back to Search",
      queryLogs: "Query Logs",
      refreshLogs: "Refresh Logs",
      exportLogs: "Export",
      exportingLogs: "Exporting...",
      loadingLogs: "Loading logs...",
      noLogsFound: "No query logs found for this date",
      totalQueries: "Total Queries",
      successfulQueries: "Successful",
      failedQueries: "Failed",
      averageProcessingTime: "Avg Processing Time",
      totalCost: "Total Cost",
      searchType: "Type",
      query: "Query",
      preference: "Preference",
      status: "Status",
      processingTime: "Processing Time",
      mode: "Mode",
      credits: "Credits",
      basicMode: "Basic",
      proMode: "Pro",
      papersFound: "Papers Found",
      cost: "Cost",
      analysisQuestions: "Analysis Qs",
      paperAnalysis: "Paper Analysis",
      paperAnalysisEmpty: "No paper analysis messages found for this search.",
      paperAnalysisLoadFailed: "Failed to load paper analysis messages.",
      paperAnalysisQuestion: "Question",
      paperAnalysisAnswer: "AI Answer",
      paperAnalysisSelectedRefs: "Selected refs",
      paperAnalysisEngagement: "Paper Analysis Engagement",
      paperAnalysisEngagementEmpty: "No paper analysis engagement recorded yet.",
      copies: "Copies",
      wordExports: "Word exports",
      feedbackUp: "Positive feedback",
      feedbackDown: "Negative feedback",
      latestFeedback: "Latest feedback",
      engagement: "Engagement",
      engagementLoadFailed: "Failed to load engagement data.",
      engagementUnavailable: "Missing search id; engagement data cannot be loaded.",
      engagementEmpty: "No engagement events recorded for this search yet.",
      papersSeen: "Papers seen",
      titleClicks: "Title clicks",
      fullTextClicks: "Full-text clicks",
      bookmarkAdds: "Bookmarks",
      bookmarkRemoves: "Removed bookmarks",
      csvExports: "CSV exports",
      historyOpens: "History opens",
      sidebarHistoryOpens: "Sidebar opens",
      detailHistoryOpens: "Detail opens",
      lastHistoryOpen: "Last history open",
      lastEvent: "Last event",
      seen: "Seen",
      bookmarked: "Bookmarked",
      notBookmarked: "Not bookmarked",
      timestamp: "Timestamp",
      success: "Success",
      failed: "Failed",
      seconds: "seconds",
      errorMessage: "Error Message",
      searchQueries: "Search Queries Used",
      ipAddress: "IP Address",
      userAgent: "User Agent",
      sessionId: "Session ID",
      tokenUsage: "Token Usage",
      showDetails: "Show Details",
      hideDetails: "Hide Details",
      logsRefreshed: "Logs refreshed successfully!",
      expandRow: "Expand",
      collapseRow: "Collapse",
      completeQuery: "Complete Query",
      queryDetails: "Query Details",
      searchQueriesDetails: "Search Queries",
      tokenUsageDetails: "Token Usage",
      paperResults: "Paper Results",
      paperTitle: "Title",
      paperUrl: "URL",
      relevanceScore: "Relevance Score",
      aiDetails: "AI Details",
      aiResearchQuestion: "Research Question",
      aiDesign: "Design",
      aiPopulation: "Population",
      aiExposureIntervention: "Exposure / Intervention",
      aiEndpoint: "Endpoint",
      aiStatistics: "Statistics",
      aiKeyResults: "Key Results",
      aiRationale: "Rationale",
      aiJournal: "Journal",
      aiYear: "Year",
      aiAuthors: "Authors",
      aiPmid: "PMID",
      aiPmcid: "PMCID",
      aiCitedBy: "Cited By",
      aiImages: "Images",
      noPapersFound: "No papers found",
      filters: "Filters",
      filterByStatus: "Status",
      searchInQueries: "Search queries",
      allStatuses: "All Statuses",
      clearFilters: "Reset Filters",
      user: "User",
      company: "Company",
      groupBy: "Group By",
      noGrouping: "No Grouping",
      groupByUser: "Group by User",
      groupByCompany: "Group by Company",
      adminOnly: "Admin Only",
      accessDenied: "Access Denied",
      adminRequired: "Admin access required to view this page",
      date: "Date",
      startDate: "Start Date",
      endDate: "End Date",
      today: "Today",
      yesterday: "Yesterday",
      viewingLogsFor: "Viewing logs for:",
      selectedCriteria: "Selected Criteria",
      noCriteria: "No criteria",
    },
    ja: {
      title: "MediLens",
      subtitle: "AI搭載医学論文検索",
      backToSearch: "検索に戻る",
      queryLogs: "クエリログ",
      refreshLogs: "ログを更新",
      exportLogs: "エクスポート",
      exportingLogs: "エクスポート中...",
      loadingLogs: "ログ読み込み中...",
      noLogsFound: "この日付のクエリログは見つかりません",
      totalQueries: "総クエリ数",
      successfulQueries: "成功",
      failedQueries: "失敗",
      averageProcessingTime: "平均処理時間",
      totalCost: "総コスト",
      searchType: "タイプ",
      query: "クエリ",
      preference: "ソースタイプ",
      status: "ステータス",
      processingTime: "処理時間",
      mode: "モード",
      credits: "クレジット",
      basicMode: "ベーシック",
      proMode: "プロ",
      papersFound: "論文数",
      cost: "コスト",
      analysisQuestions: "分析質問",
      paperAnalysis: "論文分析",
      paperAnalysisEmpty: "この検索の論文分析メッセージはありません。",
      paperAnalysisLoadFailed: "論文分析メッセージの読み込みに失敗しました。",
      paperAnalysisQuestion: "質問",
      paperAnalysisAnswer: "AI回答",
      paperAnalysisSelectedRefs: "選択されたrefs",
      paperAnalysisEngagement: "論文分析エンゲージメント",
      paperAnalysisEngagementEmpty: "この検索の論文分析エンゲージメントはまだありません。",
      copies: "コピー",
      wordExports: "Wordエクスポート",
      feedbackUp: "高評価",
      feedbackDown: "低評価",
      latestFeedback: "最新フィードバック",
      engagement: "エンゲージメント",
      engagementLoadFailed: "エンゲージメントデータの読み込みに失敗しました。",
      engagementUnavailable: "検索IDがないため、エンゲージメントデータを読み込めません。",
      engagementEmpty: "この検索のエンゲージメントイベントはまだありません。",
      papersSeen: "表示論文",
      titleClicks: "タイトルクリック",
      fullTextClicks: "全文クリック",
      bookmarkAdds: "ブックマーク",
      bookmarkRemoves: "ブックマーク解除",
      csvExports: "CSVエクスポート",
      historyOpens: "履歴再表示",
      sidebarHistoryOpens: "サイドバーから再表示",
      detailHistoryOpens: "履歴詳細から再表示",
      lastHistoryOpen: "最終履歴再表示",
      lastEvent: "最終イベント",
      seen: "表示済み",
      bookmarked: "ブックマーク済み",
      notBookmarked: "未ブックマーク",
      timestamp: "タイムスタンプ",
      success: "成功",
      failed: "失敗",
      seconds: "秒",
      errorMessage: "エラーメッセージ",
      searchQueries: "使用した検索クエリ",
      ipAddress: "IPアドレス",
      userAgent: "ユーザーエージェント",
      sessionId: "セッションID",
      tokenUsage: "トークン使用量",
      showDetails: "詳細を表示",
      hideDetails: "詳細を非表示",
      logsRefreshed: "ログが正常に更新されました！",
      expandRow: "展開",
      collapseRow: "折りたたむ",
      completeQuery: "完全なクエリ",
      queryDetails: "クエリ詳細",
      searchQueriesDetails: "検索クエリ",
      tokenUsageDetails: "トークン使用量",
      paperResults: "論文結果",
      paperTitle: "タイトル",
      paperUrl: "URL",
      relevanceScore: "関連性スコア",
      aiDetails: "AI抽出情報",
      aiResearchQuestion: "研究課題",
      aiDesign: "研究デザイン",
      aiPopulation: "対象集団",
      aiExposureIntervention: "曝露・介入",
      aiEndpoint: "評価項目",
      aiStatistics: "統計",
      aiKeyResults: "主要結果",
      aiRationale: "根拠",
      aiJournal: "掲載誌",
      aiYear: "年",
      aiAuthors: "著者",
      aiPmid: "PMID",
      aiPmcid: "PMCID",
      aiCitedBy: "被引用数",
      aiImages: "画像",
      noPapersFound: "論文が見つかりませんでした",
      filters: "フィルター",
      filterByStatus: "ステータス",
      searchInQueries: "クエリを検索",
      allStatuses: "すべてのステータス",
      clearFilters: "フィルターをリセット",
      user: "ユーザー",
      company: "会社",
      groupBy: "グループ化",
      noGrouping: "グループ化なし",
      groupByUser: "ユーザー別",
      groupByCompany: "会社別",
      adminOnly: "管理者のみ",
      accessDenied: "アクセス拒否",
      adminRequired: "このページを表示するには管理者権限が必要です",
      date: "日付",
      startDate: "開始日",
      endDate: "終了日",
      today: "今日",
      yesterday: "昨日",
      viewingLogsFor: "表示中のログ:",
      selectedCriteria: "選択された条件",
      noCriteria: "条件なし",
    },
  };;
